import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { DescargasService } from '../service';

@Component({
  selector: 'app-descargas',
  templateUrl: './descargas.component.html',
  styleUrls: ['./descargas.component.scss'],
  standalone: false,
})
export class DescargasComponent implements OnInit, OnDestroy {
  private breakpointObserver = inject(BreakpointObserver);
  private descargasService = inject(DescargasService);

  public descargasPendientes = 0;
  public hayDescargasNuevas = false;
  public menuAbierto = false;

  // Subscripciones
  private descargasSub?: Subscription;
  private nuevasDescargasSub?: Subscription;

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  private suscribirseADescargas(): void {
    // Suscribirse al listado de descargas para contar pendientes
    this.descargasSub = this.descargasService.descargas$.subscribe(
      (descargas) => {
        this.descargasPendientes = descargas.filter((d) => !d.ready).length;
      },
    );

    // Suscribirse a notificaciones de nuevas descargas listas
    this.nuevasDescargasSub =
      this.descargasService.nuevaDescargaLista$.subscribe(() => {
        // Solo marcar como nuevas si el menú está cerrado
        if (!this.menuAbierto) {
          this.hayDescargasNuevas = true;
        }
      });
  }

  public onMenuAbierto(isOpen: boolean): void {
    this.menuAbierto = isOpen;
    if (isOpen) {
      // Cuando se abre el menú, quitar el indicador de nuevas descargas
      this.hayDescargasNuevas = false;
    }
  }

  ngOnInit(): void {
    this.suscribirseADescargas();
  }

  ngOnDestroy(): void {
    this.descargasSub?.unsubscribe();
    this.nuevasDescargasSub?.unsubscribe();
  }
}
